// src/components/tauxHoraireClasse.js
// Le taux horaire d'une classe se change par une demande validée au Centre de
// Support, avec un mois d'effet (décision de Daniel du 01/11/2026). Ce module
// porte les trois appels de la fenêtre de demande (ModalTauxHoraireClasse) :
// le contexte, l'envoi et l'historique, tous sous CLASSES.UPDATE côté serveur.
//
// Même forme que droitsClassesMatieres.js : un succès rend `data` ; un refus
// métier (400, 403, 404, 409) lève une erreur qui porte `status`, `code` et le
// message du serveur, écrit pour l'agent.

import { getAuthHeaders, sortirPourAccesSuspendu } from '../services/api';

async function lireCorps(reponse) {
  let corps = null;
  try {
    corps = await reponse.json();
  } catch {
    corps = null;
  }
  if (reponse.status === 401 && corps?.code === 'ACCESS_SUSPENDED') {
    sortirPourAccesSuspendu(corps.message);
  }
  return corps;
}

async function appeler(chemin, options = {}) {
  let reponse;
  try {
    reponse = await fetch(chemin, {
      ...options,
      headers: { ...getAuthHeaders(), ...(options.body ? { 'Content-Type': 'application/json' } : {}) }
    });
  } catch {
    throw new Error('Connexion au serveur impossible.');
  }
  const corps = await lireCorps(reponse);
  if (!reponse.ok || corps?.success === false) {
    const erreur = new Error(corps?.message || reponse.statusText || 'Une erreur est survenue');
    erreur.status = reponse.status;
    erreur.code = corps?.code;
    throw erreur;
  }
  return corps;
}

/** Taux en vigueur, mois d'effet possibles, enseignants concernés, demande en attente. */
export async function lireContexteTauxClasse(classeId) {
  const corps = await appeler(`/api/classes/${encodeURIComponent(classeId)}/taux-horaire/contexte`);
  return corps?.data;
}

/** Envoie la demande ; rend { demande_id, mois_effet }. */
export async function demanderTauxClasse(classeId, { nouveauTaux, moisEffetId, motif }) {
  const corps = await appeler(`/api/classes/${encodeURIComponent(classeId)}/taux-horaire/demande`, {
    method: 'POST',
    body: JSON.stringify({ nouveau_taux: nouveauTaux, mois_effet_id: moisEffetId, motif })
  });
  return { ...(corps?.data || {}), message: corps?.message };
}

/** Les demandes de taux de la classe, la plus récente d'abord. */
export async function lireHistoriqueTauxClasse(classeId) {
  const corps = await appeler(`/api/classes/${encodeURIComponent(classeId)}/taux-horaire/historique`);
  return Array.isArray(corps?.data) ? corps.data : [];
}
